/** Bandeau de premier niveau : refuser / gérer / tout accepter. */
export const CookieBannerBar = ({ onRefuseAll, onCustomize, onAcceptAll }) => (
  <div
    data-testid="cookie-banner"
    className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-md z-50 bg-neutral-950 border border-[#c9a962]/40 text-neutral-100 shadow-2xl"
  >
    <div className="p-4 sm:p-5 space-y-3">
      <p className="text-[10px] tracking-[0.25em] uppercase text-[#c9a962]">Vos cookies</p>
      <p className="text-xs leading-relaxed text-neutral-300">
        Nous utilisons uniquement les <strong>cookies strictement nécessaires</strong> au fonctionnement du site
        (authentification, session, sécurité). Vous pouvez activer facultativement d'autres catégories pour
        améliorer votre expérience. Vos choix sont conservés 180 jours et modifiables à tout moment.
        {" "}<a href="/confidentialite" className="text-[#c9a962] hover:underline">En savoir plus</a>.
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 pt-1">
        <button
          data-testid="cookie-refuse-all"
          onClick={onRefuseAll}
          className="px-3 py-2 text-[10px] tracking-widest uppercase border border-neutral-700 text-neutral-400 hover:border-neutral-500"
        >
          Refuser
        </button>
        <button
          data-testid="cookie-customize"
          onClick={onCustomize}
          className="px-3 py-2 text-[10px] tracking-widest uppercase border border-neutral-700 text-neutral-300 hover:border-[#c9a962] hover:text-[#c9a962]"
        >
          Gérer
        </button>
        <button
          data-testid="cookie-accept-all"
          onClick={onAcceptAll}
          className="col-span-2 sm:col-span-1 px-3 py-2 text-[10px] tracking-widest uppercase bg-[#c9a962] text-neutral-950 font-semibold hover:bg-[#d5b675]"
        >
          Tout accepter
        </button>
      </div>
    </div>
  </div>
);

export default CookieBannerBar;
